export {default} from "./childCategory.js";
